/* Interactive Learning tab — the things that teach well by doing: Screen
 * (Components + Surfaces playgrounds) and Workflows. Journeys + Identity are
 * NOT here (they live in Reference, explained beautifully without fiddly UI). */
import React, { useState } from "react";
import { Layers, Workflow as WorkflowIcon } from "lucide-react";
import { ComponentsPlayground } from "./ComponentsPlayground";
import { SurfacesPlayground } from "./SurfacesPlayground";
import { WorkflowsPlayground } from "./WorkflowsPlayground";

export function InteractiveSection() {
  const [tab, setTab] = useState<"screen" | "workflows">("screen");
  const [screenView, setScreenView] = useState<"components" | "surfaces">("components");

  return (
    <div className="gd-section">
      <div className="gd-section-intro">
        <h2>Interactive learning</h2>
        <p>Play with the building blocks and watch them react — flip an option, compose a screen, run a workflow, and see exactly what happens (and the JSON it produces).</p>
      </div>

      <div className="gd-subnav">
        <button type="button" className={"gd-subnav-btn" + (tab === "screen" ? " active" : "")} onClick={() => setTab("screen")}>
          <Layers size={14} /> Screen
        </button>
        <button type="button" className={"gd-subnav-btn" + (tab === "workflows" ? " active" : "")} onClick={() => setTab("workflows")}>
          <WorkflowIcon size={14} /> Workflows
        </button>
      </div>

      {tab === "screen" ? (
        <div className="gd-fade">
          <div className="gd-subnav" style={{ marginBottom: 16 }}>
            <button type="button" className={"gd-subnav-btn" + (screenView === "components" ? " active" : "")} onClick={() => setScreenView("components")}>
              Components
            </button>
            <button type="button" className={"gd-subnav-btn" + (screenView === "surfaces" ? " active" : "")} onClick={() => setScreenView("surfaces")}>
              Surfaces
            </button>
          </div>
          <div key={screenView} className="gd-fade">
            {screenView === "components" ? <ComponentsPlayground /> : <SurfacesPlayground />}
          </div>
        </div>
      ) : (
        <div className="gd-fade"><WorkflowsPlayground /></div>
      )}
    </div>
  );
}
